<template>
  <div id="typeDesignMenuDigital">
    <oldDesignCustomMenu
      :menuId="menuId"
      :typeLanguage="typeLanguage"
      v-if="params.typeDesignCustomMenu === 0"
      :menu="menu"
    />
    <newDesignCustomMenu
      :menuId="menuId"
      :typeLanguage="typeLanguage"
      v-if="params.typeDesignCustomMenu === 1"
      :menu="menu"
    />
  </div>
</template>

<script>

import oldDesignCustomMenu from '@/components/menuDigital/designs/oldDesignCustomMenu';
import newDesignCustomMenu from '@/components/menuDigital/designs/newDesignCustomMenu';
export default {
  props: ['menuId', 'typeLanguage', 'menu'],
  components: {
    oldDesignCustomMenu,
    newDesignCustomMenu
  },
  data () {
    return {
      typeDesign: 'old'
    };
  },
  mounted () {
  },
  updated () {
  },
  destroyed () {
  },
  computed: {
  },
  methods: {
    changeTypeDesign (type = 'old') {
      this.typeDesign = type;
    }
  }
};
</script>
<style lang="scss">
  #typeDesignMenuDigital{
    .change-type-design-menu-digital{
      position: fixed;
      bottom: 20px;
      right: 20px;
      border: 0;
      font-weight: bold;
      border-radius: 50%;
      width: 50px;
      height: 50px;
      background: white;
      color: black;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      box-shadow: 0px 0px 12px 1px black;
      cursor: pointer;
      padding: 6px;
    }
  }
</style>
